export default "__VITE_ASSET__CUUS6XGN__"